import ReadOnlyTextFieldBase from "components/widgets/readOnlyTextField/readOnlyTextField.client.base"
import { Component } from "vue-property-decorator"

@Component
export default class ReadOnlyTextWeb extends ReadOnlyTextFieldBase {}
